import React from "react";

const Contact = () => {
    return (
        <>
                <div>Contact me</div>
        </>

    );
};

export default Contact;